import { ChildMarkdownRemark } from "types/cf-utils/types";
import { ObjectSchema, ObjectType } from "superstruct/lib/utils";
import {
  Struct,
  any,
  assign,
  boolean,
  nullable,
  object,
  omit,
  optional,
  string,
} from "superstruct";

export type ContentToChildren<T> = Omit<T, "content"> & {
  children: React.ReactNode;
};

export const nullUndefined = <T, S>(value: Struct<T, S>) =>
  optional(nullable(value));

export const contentToChildren = <A extends ObjectSchema>(
  struct: Struct<ObjectType<A>, A>,
) => assign(omit(struct, ["content"]), object({ children: any() }));

export const modelAcceptHasParentLink = <A extends ObjectSchema>(
  struct: Struct<ObjectType<A>, A>,
) => assign(struct, object({ hasParentLink: optional(boolean()) }));

export const modelWithStringAndChildMarkdownRemark = (stringName: string) =>
  object({
    [stringName]: string(),
    childMarkdownRemark: ChildMarkdownRemark,
  });
